<!-- Confirmation Dialog -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="modalConfig"
      [visible]="false"
      (confirmed)="onConfirmGenerate()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
